import React from 'react';
function SearchIcon({ width, height }) {
    return (
        <svg className="icon search-icon" viewBox="0 0 20 20" width={width} height={height}>
            <path
                d="M7.5 0C11.642 0 15 3.358 15 7.5c0 1.8-.635 3.454-1.693 4.746l6.469 6.47c.293.292.293.767 0 1.06-.267.266-.683.29-.977.072l-.084-.072-6.469-6.469C10.954 14.365 9.301 15 7.5 15 3.358 15 0 11.642 0 7.5 0 3.358 3.358 0 7.5 0zm0 1.5c-3.314 0-6 2.686-6 6s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6z"
                transform="translate(-325 -39) translate(325 39)"
            />
        </svg>
    );
}

export default SearchIcon;
